import React from 'react'
import { forEach } from 'lodash'
import popup from '~/views/Popup/popup'
import { Helmet } from 'react-helmet'
import './styles.css'
window.popup = popup

class RichText extends React.Component {
	constructor (props) {
			super()
			this.state = {
					scriptTags: [],
					rawHTML: null
			}
		this.scriptTags = []	
	}

	componentDidMount() {
		// Create a temporary node to hold the raw html from the CMS
		const rawHtmlNode = document.createElement('div')
		if(this.props.data){
			rawHtmlNode.innerHTML = this.props.data.rawText
		}
		
		// Pull out any script tags from that raw html
		const scriptTags = rawHtmlNode.getElementsByTagName('script')

		// Copy each script tag and re-append to the dom so that they will execute
		//   (React doesn't execute code inside of script tags inserted at runtime)
		forEach(scriptTags, (scriptTag) => {
			const newTag = document.createElement('script')
		// Manually copy over attributes
		//   (React doesn't seem to execute code in a script tag made with `Node#copyNode()`)
			scriptTag.src && (newTag.src = scriptTag.src)
			scriptTag.textContent && (newTag.textContent = scriptTag.textContent)
			this.scriptTags.push(newTag)
			scriptTag.parentElement.removeChild(scriptTag)
		// Add each scriptTag to an array so that we can clean up on unmount
			this.setState({
				...this.state,
				scriptTags: [...this.state.scriptTags, newTag],
			})
		})
		this.setState({
			...this.state,
				rawHTML: rawHtmlNode.innerHTML.toString()
		})
	}

	componentWillUnmount () {
		// remove each scriptTag from the DOM
		forEach(this.state.scriptTags, (scriptTag) => {
			scriptTag.remove()
		})
	}

	render(){
		return(
			<div className="ancillary-container rich-text" ref={(el) => { this.container = el }}>
			{this.scriptTags.length > 0 ? 
					<Helmet>
						<script type="text/javascript">{`${this.scriptTags[0].textContent}`}</script>
					</Helmet>
				:''}
				{ this.state.rawHTML &&
					<div>
						{(this.props.data && this.props.data.title) && <div className="title">{this.props.data.title}</div> }
						<div className="ancillary-pages" dangerouslySetInnerHTML={ { __html: this.state.rawHTML } }></div> 
					</div>
				}
			</div>
		)
	}

}

export default RichText